import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import ReportCollection from "@/classes/ReportCollection";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
// @ts-ignore
import Datepicker from "vuejs-datepicker";
let UserMonthly = class UserMonthly extends Vue {
    getReports(tariffId) {
        return this.$data.reports.getReportsForTariffCurrentMonth(tariffId);
    }
    calculateAvailableHours() {
        const start = window.dateHandler
            .getStartOfMonth(this.$store.getters.getSelectedDate)
            .format("YYYY-MM-DD");
        let totalHours = 0;
        for (let i = 0; i < moment(start).daysInMonth(); i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    isNonWorkingDay(date) {
        const holidayColl = this.$data.holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 ||
            moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    isSameWeek(index, reports, currentWeek, item) {
        if (index !== 0) {
            const previousWeek = this.getWeek(reports[index - 1].date);
            if (previousWeek !== currentWeek) {
                item._rowVariant = "info";
            }
        }
        else {
            item._rowVariant = "info";
        }
    }
    getWeek(date) {
        return window.dateHandler.getWeekNumber(date);
    }
    shortDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }
    dateToDay(date) {
        return moment(date).format("ddd");
    }
    navigateToHome() {
        this.$router.push({ name: "Home" });
    }
    selectDateFromCalendar() {
        this.$store.commit("setSelectedDate", {
            date: window.dateHandler.convertToUTCTime(this.$data.selectedDate),
        });
        this.$data.selectedDate = this.$store.getters.getSelectedDate;
        this.getDateInfo();
    }
    selectPreviousMonth() {
        const newDate = window.dateHandler.subtractMonths(this.$store.getters.getSelectedDate, 1);
        //handle if the new date is not in the same year we need to fetch new holidays
        if (window.dateHandler.areDatesInSameYear(this.$store.getters.getSelectedDate, newDate) === false) {
            const thisYear = moment(newDate).format("YYYY");
            this.$store.dispatch("loadHolidays", { year: thisYear, force: true });
        }
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.$data.availableHours = this.calculateAvailableHours();
    }
    selectNextMonth() {
        const newDate = window.dateHandler.addMonths(this.$store.getters.getSelectedDate, 1);
        //handle if the new date is not in the same year we need to fetch new holidays
        if (window.dateHandler.areDatesInSameYear(this.$store.getters.getSelectedDate, newDate) === false) {
            const thisYear = moment(newDate).format("YYYY");
            this.$store.dispatch("loadHolidays", { year: thisYear, force: true });
        }
        this.$store.commit("setSelectedDate", {
            date: moment(newDate).format("YYYY-MM-DD"),
        });
        this.getDateInfo();
        this.$data.availableHours = this.calculateAvailableHours();
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
};
UserMonthly = __decorate([
    Component({
        data() {
            return {
                reports: null,
                tariffs: null,
                selectedDate: this.$store.getters.getSelectedDate,
                dateInfo: this.$store.getters.getDateInfo,
                theme: this.$store.getters.getTheme,
                filter: "",
                employee: null,
                headers: [
                    { text: "Week", value: "week", width: "15%", align: "left" },
                    { text: "Day", value: "day", width: "15%", align: "left" },
                    { text: "Date", value: "date", width: "15%", align: "left" },
                    { text: "Hours", value: "hours", width: "15%", align: "left" },
                    { text: "Comment", value: "comment", width: "55%", align: "left" },
                ],
                availableHours: 0,
            };
        },
        components: {
            IconBox,
            IconBoxContent,
            Datepicker,
            WhiteBox,
        },
        created() {
            this.$store.commit("setSelectedDate", { date: new Date() });
            this.$data.tariffs = this.$store.getters.getGlobalTariffs;
            this.$data.employee = this.$store.getters.getLoggedInUser;
            this.$data.theme = this.$store.getters.getTheme;
            this.$data.holidays = this.$store.getters.getHolidays;
            this.$data.availableHours = this.calculateAvailableHours();
            this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate);
            window.eventBus.$on("selectedMonthReportsUpdated", () => {
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(this.$store.getters.getSelectedMonthReports); //create a report collection
                if (tempReports !== undefined) {
                    this.$data.reports = tempReports;
                    this.getDateInfo();
                }
            });
            /*
            const storeReports = this.$store.getters.getReports[moment(this.$store.getters.getSelectedDate).format("YYYY-MM")+this.$data.employee.userId];
            if(storeReports !== undefined && this.$data.tariffs !== null){
              this.$data.reports = storeReports;
            }
        
            (window as any).eventBus.$on('loadReportsCurrent',() => {
              const tempReports: ReportCollection = this.$store.getters.getReports[moment(this.$store.getters.getSelectedDate).format("YYYY-MM")+this.$data.employee.userId];
              if(tempReports !== undefined){
                Vue.set(this.$data, 'reports', tempReports);
                this.$data.reports = null;
                this.$data.reports = tempReports as ReportCollection;
                this.getDateInfo();
              }
            });
        */
        },
    })
], UserMonthly);
export default UserMonthly;
